import React from 'react';
import Answer from '../molecules/Answer';
import Question from '../molecules/Question';
import {makeStyles} from '@material-ui/core';

const Form = (props) => {
    const classes = useStyles();

    return (
        <>
            {
                props.list.sort((a, b) => a.order - b.order).map((data, index) => {
                    return (
                        <div className={classes.root} key={index}>
                            <Question text={data.question}/>
                            <Answer grade={props.grade} value={data.value} name={data.name} changeHandler={(value) => {
                                props.changeHandler(props.list, index, value)
                            }} direction={data.direction}/>
                            <div className={classes.intro}>
                                <p>전혀 그렇지 않다</p>
                                <span>보통이다</span>
                                <p>매우 그렇다</p>
                            </div>
                        </div>

                    )
                })
            }
        </>
    );
};

const useStyles = makeStyles({
    root: {
        boxSizing: 'border-box',
        padding: '0 22.5px',
        '& + &': {
            marginTop: '33.6px',
        }
    },
    intro: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '10px',
        color: '#a5a5a5',
        justifyContent: 'space-between',
        marginTop: '0.5vh',
        letterSpacing: 'normal',
        '& span' : {
            marginLeft: '-22.5px',
        }
    }
});

export default Form;
